export default "https://assets-v2.scaler.com/packs/files/problem_solved_nudge.4eb1b5.webp";